import React from 'react';
import {connect} from 'react-redux';
import {Field} from '@nexios/frontend-forms';
import _ from 'lodash';
import FieldWrapper from '../FieldWrapper';
import Checkbox from '../Checkbox';
import Dropdown from '../Dropdown';
import styled, {withTheme} from 'styled-components';

const DEFAULT_LABEL = 'Houd mij op de hoogte over nieuwe ontwikkelingen.';

const StyledOptIn = styled.div`
  margin: ${props => props.theme.optInDisplay?.margin};
`;

const SideBySide = styled.div`
  display: grid;
  grid-template-columns: ${props => props.theme.optInDisplay?.sideBySideColumns || '94px 1fr'};
  align-items: top;
  gap: ${props => props.theme.optInDisplay?.sideBySideGap || '8px'};
`;

const SideBySideLabel = styled.div`
  color: ${props => props.theme.optInDisplay?.sideBySideLabel?.color};
  font-size: ${props => props.theme.optInDisplay?.sideBySideLabel?.fontSize};
  font-weight: ${props => props.theme.optInDisplay?.sideBySideLabel?.fontWeight};
  line-height: ${props => props.theme.optInDisplay?.sideBySideLabel?.lineHeight};
`;

const NewsletterOptIn = ({newsletterOptIn, label, noMargin, theme}) => {
  const optInLabel = label || DEFAULT_LABEL;

  let field;
  if (newsletterOptIn === 'dropdown' && theme?.optInDisplay?.layout === 'sideBySide') {
    field = <Field
      name='allowNewsletter'
      component={() => <SideBySide>
        <Field
          name='allowNewsletter'
          list='optInChoices'
          placeholder='Kies'
          component={FieldWrapper}
          inputComponent={Dropdown}
          hideLabel
          noMargin={noMargin}
        />
        <SideBySideLabel>{optInLabel}</SideBySideLabel>
      </SideBySide>}
    />;
  } else if (newsletterOptIn === 'dropdown') {
    field = <Field
      label={optInLabel}
      name='allowNewsletter'
      list='optInChoices'
      placeholder='Maak een keuze'
      component={FieldWrapper}
      inputComponent={Dropdown}
      style={noMargin ? {marginTop: '5px'} : null}
      noMargin={noMargin}
    />;
  } else {
    field = <Field
      name='allowNewsletter'
      label={optInLabel}
      component={FieldWrapper}
      inputComponent={Checkbox}
      hideLabel
      subtle
      style={noMargin ? {marginTop: '5px'} : null}
      noMargin={noMargin}
    />;
  }

  if (noMargin) {
    return field;
  }
  return <StyledOptIn>{field}</StyledOptIn>;
};

export default connect(state => ({
  newsletterOptIn: _.get(state, ['reducer', 'formContext', 'newsletterOptIn'])
}))(withTheme(NewsletterOptIn));
